import styles from "../../pages/Calendar/Calendar.module.scss";
import leftArrow from "../../images/left_arrow_month_new.png";
import rightArrow from "../../images/right_arrow_month_new.png";

const MonthNavigation = ({
    currentDate,
    currentMonth,
    currentYear,
    onChangeMonth,
    getMonthName,
    minMonth,
    maxMonth
}) => (
    
    <div className={styles.navigation}>
        <button
            className={styles.arrow}
            onClick={() => onChangeMonth(-1)}
            disabled={currentDate.getMonth() <= minMonth}
        >
            <img className={styles.arrow_img} src={leftArrow} alt="стрелка влево" />
        </button>

        <div className={styles.monthName}>{getMonthName(currentMonth)} {currentYear}</div>

        <button
            className={styles.arrow}
            onClick={() => onChangeMonth(1)}
            disabled={currentDate.getMonth() >= maxMonth}
        >
            <img className={styles.arrow_img} src={rightArrow} alt="стрелка вправо" />
        </button>
    </div>
);

export default MonthNavigation;